import { render, staticRenderFns } from "./ImportCard.vue?vue&type=template&id=cabbd9f2&"
import script from "./ImportCard.vue?vue&type=script&lang=js&"
export * from "./ImportCard.vue?vue&type=script&lang=js&"
import style0 from "./ImportCard.vue?vue&type=style&index=0&id=cabbd9f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports